"use client";

import useTranslate from "@app/_hooks/useTranslate";
import { Dialog } from "@components/ngg";
import { XIcon } from "@ngg/icons";
import type { Dispatch, SetStateAction } from "react";

const ToolTip = ({
  open,
  setOpen
}: {
  open: boolean;
  setOpen: Dispatch<SetStateAction<boolean>>;
}) => {
  const t = useTranslate();

  return (
  <>
    <button
      type="button"
      tabIndex={-1}
      onClick={() => setOpen(true)}
      className="ml-4 text-sm text-grey-300 hover:underline"
    >
      {t("whatIsAStrongPassword")}
    </button>
    <Dialog
      open={open}
      onClose={() => setOpen(false)}
      title={t("whatIsAStrongPassword")}
      subtitle={t("whatIsAStrongPasswordTooltip")}
      alignment="top"
      classNames={{
        backdrop: "bg-black/70",
        panel: "max-w-[420] w-full pt-12 pb-10 px-6 text-left mt-1/4",
        panelHeader: "px-0",
        title: "text-lg  ",
        subtitle: "mt-4  text-base",
      }}
    >
      <button
        type="button"
        onClick={() => setOpen(false)}
        className="absolute right-3 top-3 text-lg"
      >
        <XIcon />
      </button>
    </Dialog>
  </>
  );
};

export default ToolTip;
